$(function () {
    $('.js-blog-gallery').lightGallery(
        $.extend({}, lightGallerySettings, {
            selector: '.js-lightbox',
            galleryId: 1
        })
    );

    $('.js-blog-gallery').on('onBeforeOpen.lg', function() {
        freezeScroll();
    });

    $('.js-blog-gallery').on('onCloseAfter.lg', function() {
        unfreezeScroll();
    });

    $('.l-articles')
        .on('click', '.js-articles-menu', function () {
            var $nav = $('.js-articles-nav');

            $nav.slideToggle(250);
        });

    $('body').on('click', '.pager__item a', function () {
        $('.l-articles__content').slideHere(60);
    });
});
